import type { AssessmentResult } from "@peer-start/platform-contracts";
import { Card } from "@peer-start/ui";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { KnowledgeStatus } from "./KnowledgeStatus.js";

export function AssessmentBreakdown({ result }: { result: AssessmentResult }) {
  const { t } = useTranslation();
  return (
    <div className="grid gap-5 xl:grid-cols-2">
      {(["skills", "knowledge"] as const).map((kind) => (
        <Card key={kind}>
          <h2 className="mb-4 text-lg font-medium">{t(`knowledgeAssessment.${kind}`)}</h2>
          <ul className="divide-y divide-border">
            {result[kind].map((element) => (
              <li className="space-y-2 py-4 first:pt-0" key={element.id}>
                <div className="flex items-start justify-between gap-3">
                  <h3 className="text-sm font-medium">{element.title}</h3>
                  <span className="shrink-0 text-xs text-muted-foreground">
                    {t("knowledgeAssessment.correctCount", { count: element.correct, total: element.total })}
                  </span>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <KnowledgeStatus status={element.status} />
                  {element.criticalError ? (
                    <span className="inline-flex items-center gap-1 text-xs text-destructive-foreground">
                      <AlertTriangle aria-hidden="true" className="size-3.5" />
                      {t("knowledgeAssessment.criticalError")}
                    </span>
                  ) : null}
                </div>
              </li>
            ))}
          </ul>
        </Card>
      ))}
    </div>
  );
}
